import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import React, { type ReactElement } from 'react'
import { Col, Container, Row } from 'react-bootstrap'

import Image from '@/components/image/image'
import Link from '@/components/link/link'
import { generateUrlFromNode } from '@/utils/url'

import * as styles from './persons-episode.module.scss'

export type PersonsEpisodeProps = {
  readonly persons: Queries.PersonDetailFragment[]
  readonly type: 'Host' | 'Guest'
}

const PersonsEpisode = ({
  persons,
  type
}: PersonsEpisodeProps): ReactElement | null => {
  const separator = '//'
  if (isNil(persons) || isEmpty(persons)) return <></>
  return (
    <section className={`${styles.items} mt-5`}>
      <Container>
        {persons.map((item) => {
          if (isNil(item)) return null
          const {
            id,
            firstName,
            secondName,
            job,
            bio,
            photoSquare,
            disableProfilePage
          } = item
          const url =
            disableProfilePage === true ? '' : generateUrlFromNode(item)
          return (
            <Row key={id} className="mb-5 mt-2">
              <Col className="col-3 col-md-2">
                <Link to={url}>
                  <div className={styles.roundImage}>
                    <Image image={photoSquare} />
                  </div>
                </Link>
              </Col>
              <Col className="col-9 col-md-4">
                <div className={styles.name}>
                  <h3>
                    {type} {separator}
                  </h3>
                  <Link to={url}>
                    {firstName} {secondName}
                  </Link>
                </div>
                <div className="pb-3">{job}</div>
              </Col>
              <Col className={`${styles.borderCol} ps-lg-4 col-12 col-md-6`}>
                <div>{bio}</div>
              </Col>
            </Row>
          )
        })}
      </Container>
    </section>
  )
}

export default PersonsEpisode
